/* eslint-disable */

// Uses window.tsapp
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import cIf from 'classnames';
import { MailingLists } from '../src/components/molecules/mailinglists';
import { ProductSuggestionList } from '../src/components/organisms/productsuggestion/product-suggestion-list';
import _ from 'lodash';
import { CartControlContextInstance } from '../src/logic/reactcontext/cart-control-context';
import { PaymentTool } from '../src/logic/payment-tool';
import { SiteCustomizationClass, SiteCustomizationContext } from '../src/logic/reactcontext/site-customization-context';
import { DeliveryMethod, getSelectedDeliveryFromDeliveryStatus, getWholeCartDeliveryStatus } from '../src/logic/shipping-logic';
import { WholeCartDeliverySelector } from '../src/components/molecules/buytickets/whole-cart-delivery-selector';
import { EMPTY_UUID } from '../src/logic';
import { prepareTransactionData, trackEcommerceEvent, trackUserAction } from '../js/client-tracking';

const ctl = tsapp.ctl;
const Moment = require('moment');
const tr = require('ts-translate-js').default.boundTR;
const tsRest = require('ts-rest-client');
const MarkDown = require("react-markdown");
const redirect =  ctl.utilctl.redirect;
const isInFrame = ctl.utilctl.isInFrame;
const up = require('react-addons-update');
const SaleQuestionnaireFilloutManager = require('ts-common-react-controls').SaleQuestionnaireFilloutManager;
const GuestClientInfoPanel  = ctl.guestclientinfopanel.GuestClientInfoPanel; 
const SaleQuestionnaireProvider = ctl.salequestionnaireprovider;

const trN = tr;



// Delivery helper functions
const PolicyType = {
    POLICY: "POLICY",
    DISCLAIMER: "DISCLAIMER"
};

// const CartItemDeliveryMethodAvailabilityPredicates = {
//     [DeliveryMethod.MAIL]: (i) => i.DeliveryRules.IsMailDeliveryAvailable,
//     [DeliveryMethod.ETICKET]: (i) => i.DeliveryRules.IsETicketDeliveryAvailable,
//     [DeliveryMethod.BOX_OFFICE]: (i) => !i.DeliveryRules.IsDeliveryMandatory
// };



// Controls
export const OrderValidationWidget = createClass({
    displayName: "OrderValidationWidget",

    propTypes: {
        integ: PropTypes.string.isRequired,
        onContentChange: PropTypes.func,
    },

    getInitialState(){
        return {
            orderValidation:null,
            userid: tsapp.user.pi,
            publicUserAuthenticated: tsapp.user.pua,
            isBoxOfficeAvailable:false,
            isEticketDeliveryAvailable:false,
            isMailDeliveryAvailable:false,
            profile:null,
            paymentInfo:{
                Method:"creditcard",
                CardHolderName:"",
                CardHolderPostalCode: "",
                CardHolderCountry: "",
                CardHolderAddress1: "",
                CardNumber:"",
                CardExpMonth: "01",
                CardExpYear: Moment().year(),
                CVNumber:"",
            },
            selectedShippingAddressID:'00000000-0000-0000-0000-000000000000',
            shippingAddress:null,
            showDisplayShippingAddressPanel : false,
            showRemoveShippingError: false,
            hasDeliveryMethodNotSet : false,
            showParkingSuggestion: true,
            transactionInProgress :false,
            profileEditionInProgress: false,
            processing: false,
            errorOnAction: "",
            showProfileEditionError: false,
            screenX:0,
            screenY:0,
            restoreParentScrollNextRender: false,
            isWhiteLabel: false,
            policiesRequest: {},
            saleQuestionnaires: null,
            isGuestClientAuthorized: false,
            showGuestClientForm: false,
            guestClient: {},
            mailDeliveryMessage: "",
            cartResponse: null,
            createHidden3DSIFrame: false,
            show3DSChallengeIFrame: false,
        };
    },

    componentWillMount(){
        //RCOMBRIDGE_copyTrackingCookies();

        //this.urls = tsRest.get("/integration/" + this.props.integ + "/urls");

        this.loadIsWhiteLabelSetting();

        this.loadProfile();
        this.loadOrderValidation();
        this.loadOptions();
        this.loadMailDeliveryMessage();
        this.raiseContentChanged();

    },

    componentDidMount() {
        this.shippingAddressContainerRef = React.createRef();
        this.shippingAddressErrorContainerRef = React.createRef();

        const siteSettingsContext = new SiteCustomizationClass(tsapp.siteSettings);
        this.siteSettingsContext = siteSettingsContext;
    },

    componentDidUpdate(){
        this.raiseContentChanged();

        if(this.state.restoreParentScrollNextRender){
            this.restoreParentScroll();
            this.setState({restoreParentScrollNextRender:false});
        }
    },

    componentWillUnmount() {
        //this.urls.abort();

        if (this.registerProfileRequest != null) this.registerProfileRequest.abort();
        if (this.updateShippingOnItemRequest != null) this.updateShippingOnItemRequest.abort();
        if (this.updateShippingAddressRequest != null) this.updateShippingAddressRequest.abort();
        if (this.removeShippingAddressRequest != null) this.removeShippingAddressRequest.abort();
        if (this.loginRequest != null) this.loginRequest.abort();
        if (this.updateProfileRequest != null) this.updateProfileRequest.abort();
        if (this.itemRequest != null) this.itemRequest.abort();
        if (this.updateShippingOnItemsRequest != null) this.updateShippingOnItemsRequest.abort();
        if (this.prepareStandByOrderRequest != null) this.prepareStandByOrderRequest.abort();
        if (this.processTransactionRequest != null) this.processTransactionRequest.abort();
        if (this.isWhiteLabelReq != null) this.isWhiteLabelReq.abort();
        if (this.policiesReq != null) this.policiesReq.abort();
        if (this.addDonationRequest != null) this.addDonationRequest.abort();
    },

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    },

    loadProfile(){
        this.itemRequest = tsapp.mvcapi.postCtl("profile/ProfileInfo", null, { cache: false })
            .success(function(data){
                const profile = up(data.profile, { [ "PasswordValidation" ]: { $set: data.profile.Password },
                                                    [ "EmailValidation" ]: { $set: data.profile.EmailAddress }} );
                const paymentInfo = up(this.state.paymentInfo, {
                    [ "CardHolderPostalCode" ] : { $set: profile.MainAddress.PostalCode },
                    [ "CardHolderAddress1" ] : { $set: profile.MainAddress.Address1 },
                    [ "CardHolderCountry" ] : { $set: profile.MainAddress.Country }
                });
                this.setState({profile, paymentInfo, publicUserAuthenticated: profile.IsUserLoggedIn });
            }.bind(this))
            .notSuccess(function(data){
            }.bind(this));
    },

    loadOrderValidation(){
        this.itemRequest = tsapp.mvcapi.postCtl("orderValidation/OrderValidation", null, { cache: false })
                                .success(function(data){
                                    let paymentInfo;
                                    if (data.OrderValidation.GuestClient != undefined) {
                                        paymentInfo = up(this.state.paymentInfo, {
                                            [ "CardHolderPostalCode" ] : { $set: data.OrderValidation.GuestClient.postalCode }
                                        });
                                    } else {
                                        paymentInfo = up(this.state.paymentInfo, {
                                            [ "CardHolderPostalCode" ] : { $set: data.OrderValidation.BillingAddress.PostalCode },
                                            [ "CardHolderAddress1" ] : { $set: data.OrderValidation.BillingAddress.Address1 },
                                            [ "CardHolderCountry" ] : { $set: data.OrderValidation.BillingAddress.Country }
                                        });
                                    }

                                    this.setState({
                                        orderValidation:data.OrderValidation, 
                                        allShippingAddresses:data.OrderValidation.AllShippingAddress,
                                        guestClient: data.OrderValidation.GuestClient,
                                        showEditProfile: false,
                                        paymentInfo: paymentInfo
                                    });
                                    this.checkForGuestClientAuthorization();
                                    this.updateDelivery();
                                    
                                    
                                    const newSaleQuestionnaires = {};
                                    
                                    if (data.OrderValidation.Cart.UnfilledSaleQuestionnaireResult) {
                                        newSaleQuestionnaires.SaleQuestionnaireIDs = data.OrderValidation.Cart.UnfilledSaleQuestionnaireResult.SaleQuestionnaireIDs;
                                        newSaleQuestionnaires.TicketInfos = data.OrderValidation.Cart.UnfilledSaleQuestionnaireResult.TicketInfos;
                                    }
                                    this.setState({ saleQuestionnaires: newSaleQuestionnaires });
                                }.bind(this));
    },

    loadOptions() {
        //For Now only optionsInfo
        if (this.props.integ != null) {
            this.setState({processing:true});
            const integReq = this.itemRequest = tsRest.get("integration/" + this.props.integ +  "/optionproducts");
            integReq
                .finally(function(){this.setState({processing:false});}.bind(this))
                .done(function (data) {
                    this.setState({optionsInfo:data});
                }.bind(this), tsRest.handleError);
        }
    },

    loadIsWhiteLabelSetting() {
        if (this.props.integ != null) {
            this.setState({processing:true});
            const isWhiteLabelReq = this.itemRequest = tsRest.get("integration/" + this.props.integ +  "/iswhitelabel");
            isWhiteLabelReq
                .finally(function(){this.setState({processing:false});}.bind(this))
                .then(function (data) {
                    this.setState({ isWhiteLabel: data })
                    this.setTitleAccount(data ? tr("Identifiez-vous") : tr("Informations du compte Reservatech.net"));
                }.bind(this));
        }
    },

    loadMailDeliveryMessage() {
        if (this.props.integ != null) {
            this.setState({ processing: true });
            const mailDeliveryMessageReq = this.itemRequest = tsRest.get("/integration/" + this.props.integ + "/maildeliverymessage");
            mailDeliveryMessageReq
                .finally(function() { this.setState({processing: false});}.bind(this))
                .then(function(data) {
                    this.setState({ mailDeliveryMessage: data});
                }.bind(this));
        }
    },
        
    

    updateDelivery(){
        const delivStatus = getWholeCartDeliveryStatus(this.state.orderValidation.Cart.Items);

        this.setState({
            isMailDeliveryAvailable: delivStatus.isMailDeliveryAvailable,
            isEticketDeliveryAvailable: delivStatus.isEticketDeliveryAvailable,
            isBoxOfficeAvailable: delivStatus.isBoxOfficeAvailable,
            hasDeliveryMethodNotSet: delivStatus.unsetItemCount > 0
        });
    },

    handleForceDeliveryMethod(deliveryMethod, shippingFeeId) {
            this.updateShippingOnItemRequest = tsapp.mvcapi.postCtl("cart/UpdateShippingOnItems", { selectedDeliveryMethod: deliveryMethod, shippingFeeID: shippingFeeId }, { cache: false })
                                                    .success(function(){
                                                        this.loadOrderValidation();

                                                        const method = deliveryMethod == DeliveryMethod.MAIL ? 'Mail delivery' : (deliveryMethod == DeliveryMethod.ETICKET ? 'e-ticket delivery' : 'Box office');
                                                        const trackingData = {
                                                            name: 'deliveryMethodChanged',
                                                                shippingMethod: method,
                                                            item: {
                                                                    label: method
                                                            },
                                                            urlSource: window.location.href
                                                        };
                                                        trackUserAction(this.props.integ, trackingData);
                                                    }.bind(this))
                                                    .notSuccess(function(data){
                                                        this.setState({errorOnAction:data.message == "CART_IS_EMPTY" ? data.message : ""});
                                                        console.log(this.state.errorOnAction);
                                                    }.bind(this));
    },

    saveParentScroll(pos){
        this.setState({"screenX":pos.x, "screenY":pos.y});
    },

    restoreParentScroll(){
        if(isInFrame()) {
            if (window.scrollParentTo){
                window.scrollParentTo(this.state.screenX, this.state.screenY);
            }
        } else 
            window.scrollTo(this.state.screenX, this.state.screenY);
    },

    initPoliciesRequest(policiesToShow) {
        let policies = {};
        _.forEach(policiesToShow, (policy) => {
            // Ajoute le priceRequest de membre dans le dictionnaire par event
            _.setWith(policies, "[" + policy.id + "][checked]", false, Object);
            _.setWith(policies, "[" + policy.id + "][type]", policy.type, Object);
        });

        this.setState({policiesRequest: policies});
    },

    checkAllPoliciesCheckedBeforeProcess() {

        const notCheckedId = _.findKey(this.state.policiesRequest, ['checked', false]);
        return (notCheckedId == null);
    },

    checkHavePoliciesByType(type) {

        const policies = _.findKey(this.state.policiesRequest, ['type', type]);
        return (policies != null);
    },

    handleOnPolicyCheckedChange(id, checked) {

        this.state.policiesRequest[id]["checked"] = checked;
        this.setState({policiesRequest: this.state.policiesRequest});
    },

    handleOnChangeEmail(email){
        this.setState({email});
    },

    handleOnChangePassword(password){
        this.setState({password});
    },

    handleOnProfileChange(profile){
        this.setState ({profile});
    },

    handleOnChangePaymentInfo(paymentInfo){
        this.setState({paymentInfo});
    },

    handleOnConnect(){
        // Google Analytics virtual page
        // if(typeof dataLayer != 'undefined') dataLayer.push({ event: 'form-submit', "form-type": 'formulaire-connexion-compte' });
        const trackingData = {
            name: 'login',
                loginMethod: 'Reservatech Login',
            urlSource: window.location.href
        };
        trackUserAction(this.props.integ, trackingData);
        
        // Refresh the cart status widget if applies.
        if(typeof window.RefreshCartIFrame != 'undefined') window.RefreshCartIFrame(); // This is a global site function. We will have to do something for integrations that don't have a small cart!
        
        if(typeof window.RefreshCart !== 'undefined') window.RefreshCart();

        this.itemRequest = tsapp.mvcapi.postCtl("login/CurrentUserInfo")
                                .success(function(data){
                                    this.setState({ userid:data.user.pi, publicUserAuthenticated: data.user.pua })
                                    this.loadProfile();
                                    // Mainly for IS3, in order to reload UserSessionInfoWidget in top bar
                                    if (tsapp.integrationEventsEmitter)
                                        tsapp.integrationEventsEmitter.emit("onAccountChange");
                                }.bind(this))
                                .notSuccess(function(data){
                                    this.setState({errorOnAction:(data.message == "CART_IS_EMPTY") ? data.message: ""});
                                }.bind(this));
        this.loadOrderValidation(EMPTY_UUID);
    },

    handleOnUpdateSelectedShippingAddress(selectedShippingAddressID){
        this.setState({selectedShippingAddressID});
    },

    handleOnShowShippingAddressPanel(){
        this.setState({showDisplayShippingAddressPanel : true});
    },

    handleOnCloseShippingAddressPanel(){
        this.setState({showDisplayShippingAddressPanel : false});
    },

    handleOnUpdateCart(){
        // If we reload the cart, we have a reason to do it, let's reload the small cart status as well
        if(typeof window.RefreshCartIFrame != 'undefined') window.RefreshCartIFrame(); // This is a global site function. We will have to do something for integrations that don't have a small cart!
        
        if(typeof window.RefreshCart !== 'undefined') window.RefreshCart();

        CartControlContextInstance.cartControl.refreshCart();
        
        this.loadOrderValidation();

        this.setState({cartResponse: {
            cartUpdated: true
        }});
    },

    handleOnCancelEdition(){
        this.setState({showEditProfile:false, showRegisterProfile:false, profileEditionError:null, showProfileEditionError:false})
        this.loadProfile();

        this.setState({restoreParentScrollNextRender:true});
    },

    handleOnCompleteRegisterProfile(){
        this.setState({profileEditionInProgress: true, showProfileEditionError:false});

        // Google Analytics virtual page
        // if(typeof dataLayer != 'undefined') dataLayer.push({ event: 'form-submit', "form-type": 'formulaire-creation-compte' });
            const trackingData = {
                name: 'register',
                urlSource: window.location.href
            };
            trackUserAction(this.props.integ, trackingData);
        
        //TOCHECK - Lambda function replacing standart function
        this.registerProfileRequest = tsapp.mvcapi.postCtl("profile/register", {profile:this.state.profile})
                                            .success(() => {
                                                this.loginRequest = tsapp.mvcapi.postCtl("login/login", {email:this.state.profile.EmailAddress, password:this.state.profile.Password})
                                                                        .success(function(){
                                                                            this.setState({ showRegisterProfile:false, profileEditionInProgress: false, restoreParentScrollNextRender:true});
                                                                            this.handleOnConnect();
                                                                        }.bind(this));
                                            })
                                            .notSuccess(function(data){
                                                this.setState({ showProfileEditionError:true,
                                                                profileEditionInProgress: false,
                                                                profileEditionError: data});
                                            }.bind(this));
    },


    addDonationToCart(eventId, donation) {
        this.setState({ addingCard: true });

        this.addDonationRequest = tsapp.mvcapi.postCtl("buyticket/adddonationtocart",{
                                        eventId: eventId,
                                        donation: donation
                                    })
                                    .success(function(data){
                                        this.handleOnUpdateCart();
                                        this.loadOrderValidation();
                                        this.setState({cartResponse: data});
                                    }.bind(this))
                                    .notSuccess(function(data){
                                        this.setState({cartResponse: data});
                                    }.bind(this));
    },

    clearError() {
        this.setState({ 
            showProfileEditionError:false,
            profileEditionInProgress: false,
            profileEditionError: null});
    },

    handleOnCompleteUpdateProfile(){
        this.setState({profileEditionInProgress: true, showProfileEditionError:false, profileEditionError:null});

        this.updateProfileRequest = tsapp.mvcapi.postCtl("profile/UpdateProfile", {profile:this.state.profile}, { cache: false })
        .success(function(){
            this.setState({showEditProfile:false, profileEditionInProgress: false, restoreParentScrollNextRender:true});
            this.loadProfile();
            this.loadOrderValidation();
        }.bind(this))
        .notSuccess(function(data){
            this.setState({
                showProfileEditionError:true,
                profileEditionInProgress: false,
                profileEditionError: data,
                errorOnAction:(data.message == "PROFILE_IS_EMPTY") ? data.message: ""
            });
        }.bind(this));

        this.setState({restoreParentScrollNextRender:true});
    },

    handleOnRegisterProfile(){
        this.setState({showRegisterProfile:true});

        this.saveParentScrollAndScrollTop();
    },

    saveParentScrollAndScrollTop() {
        if(isInFrame()) {
            // @ts-ignore
            if(getScrollPosition)
                // @ts-ignore
                getScrollPosition(function(pos){this.saveParentScroll(pos);}.bind(this));
            
            // @ts-ignore
            if(scrollParentTop)
                // @ts-ignore
                scrollParentTop();
        } else {
            this.saveParentScroll({ x: window.scrollX, y: window.scrollY });
            window.scrollTo(0, 0);
        }    
    },

    handleOnEditProfile(withScroll = true){
        this.setState({showEditProfile:true});

        if (withScroll) {
            this.saveParentScrollAndScrollTop();
        }
    },

    handleOnFailedProfileEditionOK(){
        this.setState({showProfileEditionError: false});
    },

    handleOnValidationIncorrect(){
        this.setState({showProfileEditionError:true});
    },

    async handleOnCompleteTransaction(){
        const allPoliciesAreChecked = this.checkAllPoliciesCheckedBeforeProcess();
        const addressValidationIsValid = this.checkIfAddressValidationIsValid();
        if(allPoliciesAreChecked && addressValidationIsValid) {
            //Build le requestmodel a passé
            const req = {
                ParkingQty: 0,
                ShippingAddressID: this.state.selectedShippingAddressID == EMPTY_UUID
                ? this.state.orderValidation.BillingAddress.ID
                : this.state.selectedShippingAddressID,
                CartTotalValidation : this.state.orderValidation.Cart.Total
            };

            this.setState({
                orderPrepareResult : null,
                orderProcessingResult : null,
                transactionInProgress : true
            });
            
            //TOCHECK - Lambda function replacing standard function

            // The PMT Tool is a helper that will help us process the payment with 3DS or not.
            const pmtTool = new PaymentTool(tsapp.mvcapi);

            // We must provide Iframes when the tool need them
            pmtTool.on3DSHiddenIFrameNeeded = async () => {
                return new Promise((resolve, _reject) => {
                    this.setState({
                        createHidden3DSIFrame: true,
                    }, () => {
                        resolve(this.refs.threeDSHiddenIframeRef);
                    });
                });
            }
            pmtTool.on3DSHiddenIFrameDone = () => { this.setState({ createHidden3DSIFrame: false }); }

            pmtTool.on3DSChallengeIFrameNeeded = (width, height) => {
                return new Promise((resolve, _reject) => {
                    this.setState({
                        show3DSChallengeIFrame: true,
                    }, () => {
                        // Set its size according to ACS requirement
                        this.refs.threeDSChallengeIframeRef.style.width = width + "px";
                        this.refs.threeDSChallengeIframeRef.style.height = height + "px";

                        resolve(this.refs.threeDSChallengeIframeRef);
                    });
                });
            }
            pmtTool.on3DSChallengeIFrameDone = () => { this.setState({ show3DSChallengeIFrame: false }); }
            
            // Process the transaction
            try {
                const result = await pmtTool.processSaleTransaction(
                    this.state.orderValidation.Cart.Total, 
                    this.state.selectedShippingAddressID == EMPTY_UUID ? this.state.orderValidation.BillingAddress.ID : this.state.selectedShippingAddressID,
                    this.state.paymentInfo,
                    true // Send email
                )

                
                
                // We don't want to fail in a way that the user won't see there confrimation!
                try{
                    //if (clientTracking != undefined) {
                    const cart = this.state.orderValidation.Cart;
                    const trackingData = prepareTransactionData(cart, result.orderProcessingResult.cartID);
                    await trackEcommerceEvent(this.props.integ, trackingData);
                    //}
                    if(typeof window.RefreshCartIFrame != 'undefined') window.RefreshCartIFrame(); // This is a global site function. We will have to do something for integrations that don't have a small cart!

                    if(typeof window.RefreshCart !== 'undefined') window.RefreshCart();
                } catch (err) {}

                let orderConfirmationPath = "../";
                if (tsapp.isShop) {
                    orderConfirmationPath += tsapp.shopBasePath;
                }
                orderConfirmationPath += "/orderconfirmation/OrderConfirmationWidget?ias=true&dse=true&cid=" + result.orderProcessingResult.cartID;
                window.location.href = orderConfirmationPath;

            } catch (err) {
                /** @type{import('../src/logic/payment-tool').ProcessSaleTransactionResult} */
                const result = err;

                console.log("Error processing payment : ", result);

                this.setState({ 
                    transactionInProgress : false,
                    orderPrepareResult: result.prepareStandbyOrderResult, 
                    orderProcessingResult: result.orderProcessingResult,
                 });
            }


        } else {
            const orderPrepareResult = { isSuccess: false};
            if (!allPoliciesAreChecked) {
                if(this.checkHavePoliciesByType(PolicyType.POLICY))
                    orderPrepareResult.acceptPolicies = true;
                if(this.checkHavePoliciesByType(PolicyType.DISCLAIMER))
                    orderPrepareResult.acceptDisclaimers = true;
            }

            if (!addressValidationIsValid) {
                orderPrepareResult.missingAddress1 = this.state.orderValidation.AddressValidationServiceStreetCheckEnabled && _.isEmpty(this.state.paymentInfo.CardHolderAddress1);
                orderPrepareResult.missingPostalCode = this.state.orderValidation.AddressValidationServicePostalCodeCheckEnabled && _.isEmpty(this.state.paymentInfo.CardHolderPostalCode);
                orderPrepareResult.missingCountry = _.isEmpty(this.state.paymentInfo.CardHolderCountry);

                console.log(orderPrepareResult.missingAddress1, orderPrepareResult.missingPostalCode, orderPrepareResult.missingCountry);
            }
            
            this.setState({ orderPrepareResult: orderPrepareResult });
        }
    },

    getAllEventIdsInCart() {
        const eventsGroupByType = _.groupBy(this.state.orderValidation.Cart.Items, function(product) {

            if(product.PackageID != 0)
                return "Packages";
            else
                return "EventDates";
        });

        let eventIds = [];
        if(eventsGroupByType.EventDates !== undefined)
            eventIds = _.uniq(_.map(eventsGroupByType.EventDates, (date) => date.EventID));

            let packageEventIds = [];
        if(eventsGroupByType.Packages !== undefined)
            packageEventIds = _.head(_.uniq(_.map(eventsGroupByType.Packages, (pack) => _.map(pack.SubProducts, (prod) => prod.EventID))));

        return _.concat(eventIds, packageEventIds);
    },

    handleContinueShopping(){
        tsapp.goToHome(this.props.integ);
    },

    getUrlCompleteTransaction(baseurl, cartID) {
        let url = `../widgets/orderconfirmation?ias=true&cid=${cartID}`;

        if(baseurl) 
            url = baseurl.replace(/\{(cartid)\}/i, cartID);
        
        return url;
    },
    
    handleRefreshSaleQuestionnaire() {
        
        this.setState({ showAutoSaleQuestionnaire: false, restoreParentScrollNextRender: true });
        
        this.handleOnUpdateCart();
        
    },

    setTitleAccount(title) {
        this.setState({titleAccount: title});
    },
    
    handleOpenAutoSaleQuestionnaire(saleQuestionnaires) {            
        this.saveParentScrollAndScrollTop();
        
        this.setState({ saleQuestionnaires: saleQuestionnaires, showAutoSaleQuestionnaire: true });
    }, 

    checkForGuestClientAuthorization() {
        if (this.state.userid != EMPTY_UUID && this.state.publicUserAuthenticated) {
            this.setState({isGuestClientAuthorized: false});
        } else {
            const tempCartItems = _.orderBy(this.state.orderValidation.Cart.Items, ['IsGuestClientAuthorized'], ['asc']);
            const isGuestClientAuthorized = _.find(tempCartItems, function(item) {
                return item.IsGuestClientAuthorized == false;
            });

            this.setState({isGuestClientAuthorized: isGuestClientAuthorized != undefined ? false : true});
        }
    },

    handleOnGuestClientCreated() {
        const trackingData = {
            name: 'continueAsGuest',
            urlSource: window.location.href
        };
        trackUserAction(this.props.integ, trackingData);

        this.loadOrderValidation();
    },

    shouldUseGuestClient() {
        return (this.state.isGuestClientAuthorized && this.state.guestClient != null);
    },

    isGuestClientReadyToProceedTransaction() {
        if (_.some(this.state.orderValidation.Cart.Items, ['IsMailDelivery', true])) {
            return this.state.guestClient != null && (this.state.guestClient.address != null);
        } 
        return true;
    },

    showGuestClientForm() {
        this.setState({showGuestClientForm: true});
    },

    handleOnGuestClientCancelled() {
        this.setState({showGuestClientForm: false, showEditProfile: false});
    },

    checkIfAddressValidationIsValid() {
        let isValid = true;

        // First, check if we have a postal code or an address
        if ((this.state.orderValidation.AddressValidationServiceStreetCheckEnabled && _.isEmpty(this.state.paymentInfo.CardHolderAddress1))
            || (this.state.orderValidation.AddressValidationServicePostalCodeCheckEnabled && _.isEmpty(this.state.paymentInfo.CardHolderPostalCode))
            || ((this.state.orderValidation.AddressValidationServiceStreetCheckEnabled || this.state.orderValidation.AddressValidationServicePostalCodeCheckEnabled) 
            && _.isEmpty(this.state.paymentInfo.CardHolderCountry))) {
            isValid = false;
        }

        return isValid;
    },

    /**
     * Handler for mailing subscription.
     * It will add the mailing list id to session if it's not already checked,
     * and will delete it if it is.
     * @param {string} id 
     */
    handleMailingListSubscription(id) {
        tsRest.put(
            "session/internetsalescart/mailinglistoptins", {id: id}
        ).then((response) => {
            /** @type {import('../src/types/models/internetsalescart').InternetSalesCart} */
            const data = response;

            /** @type {import('../src/types/models/mvcapi/ordervalidation').OrderValidation} */
            const orderValidation = {...this.state.orderValidation};
            orderValidation.SelectedMailingLists = data.MailingListIdOptins;

            this.setState({
                orderValidation: orderValidation,
            });
        });
    },


    /**
     * Handler for email sharing choice.
     * It will save the choice in session, according to checkbox state.
     * @param {boolean} checked
     */
    handleEmailSharingChoice(checked) {
        tsRest.put(
            "session/internetsalescart/acceptemailsharing", {choice: checked}
        ).then((response) => {
            /** @type {import('../src/types/models/internetsalescart').InternetSalesCart} */
            const data = response;

            /** @type {import('../src/types/models/mvcapi/ordervalidation').OrderValidation} */
            const orderValidation = {...this.state.orderValidation};
            orderValidation.EmailAddressSharingChoice = data.AcceptEmailSharing;

            this.setState({
                orderValidation: orderValidation,
            });
        });
    },
    
    render(){
        // This should be elsewhere, that's horrible
        const errorMessages = {
            "CART_IS_EMPTY": tsapp.tr("Votre panier est présentement vide, la page sera actualisee"),
            "PROFILE_IS_EMPTY": tsapp.tr("Aucun profil est connecte, la page sera actualisee")
        };

        if (this.state.orderValidation == null)
            return <div className={cIf("container-fluid", this.props.integ)}><h4>{tr("ordervalidation.loading")}</h4></div>;
        
        const delivStatus = getWholeCartDeliveryStatus(this.state.orderValidation.Cart.Items);
        const cartLoaded = this.state.orderValidation.Cart != null;
        const userConnected = (this.state.userid != EMPTY_UUID && this.state.publicUserAuthenticated) || (this.shouldUseGuestClient() && this.state.guestClient != null);
        const autoSaleQuestionnaireHaveUnfilled = this.state.orderValidation.Cart.UnfilledSaleQuestionnaireResult != null && this.state.orderValidation.Cart.UnfilledSaleQuestionnaireResult.SaleQuestionnaireIDs.length > 0;
        const autoSaleQuestionnaireIsFilled = this.state.orderValidation.Cart.UnfilledSaleQuestionnaireResult != null && this.state.orderValidation.Cart.UnfilledSaleQuestionnaireResult.SaleQuestionnaireIDs.length == 0;

        const errorOnAction = this.state.errorOnAction != ""
                            ? <ctl.utilctl.ErrorOnActionMessage message={this.errorMessages[this.state.errorOnAction]}/>
                            : null;

        // Find what we consider the selected shipping method!
        const selectedShippingMethod = getSelectedDeliveryFromDeliveryStatus(delivStatus);

        let userPanel = null;
        const userAdressInfo =  <UserAddressInfo 
                                hasMailDeliveries={_.some(this.state.orderValidation.Cart.Items, ['IsMailDelivery', true])}
                                orderValidation={this.state.orderValidation}
                                onUpdateSelectedShippingAddress={this.handleOnUpdateSelectedShippingAddress}
                                selectedShippingAddressID={this.state.selectedShippingAddressID}
                                allShippingAddresses={this.state.allShippingAddresses}
                                onShowShippingAddressPanel={this.handleOnShowShippingAddressPanel}
                                onEditProfile={this.handleOnEditProfile}/>;

            
        const loginPanel = <ctl.login.LoginPanel
                            email={this.state.email} 
                            password={this.state.password}
                            isGuestClientAuthorized={this.state.isGuestClientAuthorized}
                            isWhiteLabel={this.state.isWhiteLabel}
                            onRegisterProfile={this.handleOnRegisterProfile} 
                            onChangeEmail={this.handleOnChangeEmail} 
                            onChangePassword={this.handleOnChangePassword} 
                            onConnectSuccess={this.handleOnConnect}
                            onContentChange={this.props.onContentChange}
                            handleOnTitleChange={(title) => this.setTitleAccount(title)}
                            showGuestClientForm={() => this.showGuestClientForm()}/>;

        const shouldEditGuestClient = _.isEmpty(this.state.guestClient) 
            || (_.some(this.state.orderValidation.Cart.Items, ['IsMailDelivery', true]) 
                && (this.state.guestClient.address == undefined || this.state.guestClient.address == ""))
            || this.state.showEditProfile;

        const guestClientInfo = 
            <GuestClientInfoPanel 
                guestClient={this.state.guestClient}
                isInEdition={shouldEditGuestClient}
                handleGuestClientEdition={() => this.handleOnEditProfile(false)}
                hasMailDeliveries={_.some(this.state.orderValidation.Cart.Items, ['IsMailDelivery', true])}
                onGuestClientCancelled={() => this.handleOnGuestClientCancelled()}
                onGuestClientCreated={() => this.handleOnGuestClientCreated()}
                onContentChange={this.props.onContentChange}/>;
        
        if (this.state.publicUserAuthenticated) {
            userPanel = userAdressInfo;
        } else {
            if (this.shouldUseGuestClient() || this.state.showGuestClientForm) {
                userPanel = guestClientInfo;
            } else {
                userPanel = loginPanel;
            }
        }
        
        // const shippingButtonsDef = _.filter([
        //     delivStatus.isEticketDeliveryAvailable ? { text: tr("ordervalidation.seteticketdelivery"), onClick: this.forceDeliveryMethod.bind(this, DeliveryMethod.ETICKET), selected: selectedShippingMethod === DeliveryMethod.ETICKET } : null,
        //     delivStatus.isBoxOfficeAvailable ? { text: tr("Je récupérerai mes billets au guichet"), onClick: this.forceDeliveryMethod.bind(this, DeliveryMethod.BOX_OFFICE), selected: selectedShippingMethod === DeliveryMethod.BOX_OFFICE } : null,
        //     delivStatus.isMailDeliveryAvailable ? { text: tr("ordervalidation.setmaildelivery"), onClick: this.forceDeliveryMethod.bind(this, DeliveryMethod.MAIL), selected: selectedShippingMethod === DeliveryMethod.MAIL } : null
        // ], (b) => b != null);

        // let mailDeliveryMessageSection;
        // if(cartLoaded && this.state.mailDeliveryMessage != null && this.state.mailDeliveryMessage != "")
        //     mailDeliveryMessageSection =
        //         <div className="row">
        //             <div className="col-md-12">
        //                 <div className="alert alert-warning clearfix">
        //                     <div className="col-xs-1">
        //                         <i className="fa fa-exclamation-circle fa-3x" aria-hidden="true"/>
        //                     </div>
        //                     <div className="col-xs-11"><span>{this.state.mailDeliveryMessage}</span></div>
        //                 </div>
        //             </div>
        //         </div>;

        // const wholeCartDeliverySection =
        //     <div style={{marginBottom: 20}}>
        //         <h4 style={{margin: 0}}>{tr("Récupération de votre commande")}</h4>
        //         <p>{tr("Veuillez sélectionner la méthode de récupération")}</p>
        //         <div className="row">
        //             <HorizontalButtonSelector buttons={shippingButtonsDef} className="col-md-12" />
        //         </div>
        //         {selectedShippingMethod === DeliveryMethod.MAIL ? mailDeliveryMessageSection : null}
        //     </div>;

        const displayShippingAddressPanel = (this.state.showDisplayShippingAddressPanel == true)
                                        ? <ctl.profile.ShippingAddressPanel
                                                shippingaddresses={this.state.allShippingAddresses}
                                                onCloseShippingAddress={this.handleOnCloseShippingAddressPanel}
                                                onRefreshData={this.handleOnUpdateCart}
                                                container={this.shippingAddressContainerRef.current}
                                                errorModalContainer={this.shippingAddressErrorContainerRef.current}
                                        />
                                        : null;

        const purchasePolicy = (userConnected)
                            ? null
                            :   <div className="row">
                                <div className="col-md-12">
                                    <input type="checkbox"/>
                                    <label> {tr("ordervalidation.accept")}<a href="./" target="_top"> {tr("ordervalidation.policies")}</a></label>
                                </div>
                            </div>;


        if (this.state.orderValidation.Cart.Items.length == 0)
            return (<div className={cIf("container-fluid", this.props.integ)}>
                <h3>{tr("ordervalidation.title")}</h3>
                <p>{tr("cartwidget.yourcartisempty")}</p>
                <button type="button" className="btn btn-default txt-right" onClick={this.handleContinueShopping}>{tr("cartwidget.continueshopping")}</button>
            </div>);



        let cartContentSection;
        if(cartLoaded)
            cartContentSection =
                <div>
                    <h4>{tr("Vos produits")}</h4>
                    <div className="row">
                        <div className="col-md-12">
                            <ctl.cart.CartContent
                                cart={this.state.orderValidation.Cart}
                                onUpdateCart={this.handleOnUpdateCart}
                                onContentChange={this.raiseContentChanged}
                                emphasisOnUncompletedThings={true}
                                onModifySaleQuestionnaire={this.handleOpenAutoSaleQuestionnaire}
                                integ={this.props.integ}
                            />
                        </div>
                    </div>
                </div>;

        let optionsSection;
        if (cartLoaded && this.state.optionsInfo != null && this.state.optionsInfo != "") {
            const allOptions = _.map(this.state.optionsInfo, (option) => {
                return <div className="well">
                    <h4>{(option.iconClass ? <i className={option.iconClass}></i> : null)} <a href="#" onClick={function (e) { e.preventDefault(); e.stopPropagation(); redirect(_.replace(option.url, "{lang}", tsapp.twoLetterLang)); }.bind(this)}>{option.title[tsapp.twoLetterLang]}</a></h4>
                    <MarkDown className="markdown-inline text-justify" source={option.desc[tsapp.twoLetterLang]} />
                </div>;
            });

            optionsSection =
                <div>
                    <h4>{tr("ordervalidation.addoptions")}</h4>
                    {allOptions}
                </div>;
        }

        let accountSection;
        if(cartLoaded) {
            accountSection =
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            {userPanel}
                        </div>
                        <div className="col-md-6">
                        </div>
                    </div>
                </div>;
        }

        let autoQuestionnairePanel = null;

        const autoQuestionnairePanelTitle = tr("Informations d'inscription");          
        
        if(cartLoaded && userConnected && autoSaleQuestionnaireHaveUnfilled){
            const autoQuestionButtonTitle = this.state.autoQuestionnaireFilled
                                        ? tr("Modifier vos informations d'inscription")
                                        : tr("Veuillez remplir vos informations d'inscription");
            autoQuestionnairePanel =
                (<div>
                    <h4>{autoQuestionnairePanelTitle}</h4>
                    <button type="button" className="btn btn-default txt-right" onClick={() => this.handleOpenAutoSaleQuestionnaire(this.state.saleQuestionnaires)}>{autoQuestionButtonTitle}</button>
                </div>);
        }
        
        let paymentPanel = null;
        let policiesSection = null;
        let mailingListsSection = null;
        
        const paymentPanelTitle = this.state.orderValidation.Cart != null && this.state.orderValidation.Cart.Total == 0
                                ? tr("payment.finalizetransaction")
                                : tr("payment.paymentinfo");
                                
        let canProceedTransaction = false;
        if (this.shouldUseGuestClient()) {
            if(this.isGuestClientReadyToProceedTransaction() && autoSaleQuestionnaireIsFilled) {
                canProceedTransaction = true;
            } 
        } else {
            if (cartLoaded && userConnected && autoSaleQuestionnaireIsFilled) {
                canProceedTransaction = true;
            }
        }

        if (canProceedTransaction) {
            let threeDSChallengeIframe = null;

            if(this.state.show3DSChallengeIFrame)
                threeDSChallengeIframe = <iframe 
                    ref={"threeDSChallengeIframeRef"}
                    id="payment3dschallenge_iframe" 
                    name="payment3dschallenge_iframe" 
                    style={{ 
                        width: "600px",
                        height: "300px",
                    }}>
                </iframe>;


            paymentPanel =
                (<div>
                    <h4>{paymentPanelTitle}</h4>
                    <ctl.payment.PaymentPanel 
                        className="col-sm-offset-5" minWidth="200px"
                        cart={this.state.orderValidation.Cart}
                        paymentInfo={this.state.paymentInfo}
                        onChange={this.handleOnChangePaymentInfo}
                        onCompleteTransaction={this.handleOnCompleteTransaction}
                        orderProcessingResult={this.state.orderProcessingResult}
                        orderPrepareResult={this.state.orderPrepareResult}
                        transactionInProgress={this.state.transactionInProgress}
                        integ={this.props.integ}
                        addressValidationNeeded={this.state.orderValidation.AddressValidationServiceStreetCheckEnabled}
                        postalCodeValidationNeeded={this.state.orderValidation.AddressValidationServicePostalCodeCheckEnabled}
                        onContentChange={this.raiseContentChanged}
                        canUsePrepaidCard={this.state.orderValidation.CanUsePrepaidCard}
                        threeDSChallengeIframe={threeDSChallengeIframe}
                    />
                </div>);
        }

        const currentCartEventIds = this.getAllEventIdsInCart();
        if(currentCartEventIds.length > 0 && paymentPanel != null) {
            policiesSection = <Policies eventIds={currentCartEventIds}
                                        integ={this.props.integ}
                                        raiseContentChanged={this.raiseContentChanged}
                                        onCheckedChange={this.handleOnPolicyCheckedChange}
                                        initPoliciesRequest={this.initPoliciesRequest}></Policies>;

            /** @type {import('../src/types/models/mvcapi/ordervalidation').OrderValidation} */
            const orderValidation = this.state.orderValidation;
            if (orderValidation.AvailableMailingLists.length > 0) {
                mailingListsSection = <MailingLists 
                    mailingLists={orderValidation.AvailableMailingLists}
                    selectedMailingLists={orderValidation.SelectedMailingLists}
                    askCustomerForEmailAddressSharing={orderValidation.AskCustomerForEmailAddressSharing}
                    didAcceptEmailAddressSharing={orderValidation.EmailAddressSharingChoice}
                    handleMailingListSubscription={this.handleMailingListSubscription}
                    handleEmailSharingChoice={this.handleEmailSharingChoice}
                />;
            }
        }

        const productSuggestions = <ProductSuggestionList 
                                        eventIds={currentCartEventIds} 
                                        onAddProduct={this.addDonationToCart}
                                        cartResponse={this.state.cartResponse}
                                    />;

        let ordervalidationpanel = null;

        if (!this.shouldUseGuestClient() && (this.state.showRegisterProfile || this.state.showEditProfile))
            ordervalidationpanel = <ctl.profile.EditionPanel profile={this.state.profile}
                                                                onCompleteEdition={this.state.showEditProfile
                                                                                ?this.handleOnCompleteUpdateProfile
                                                                                :this.handleOnCompleteRegisterProfile}
                                                                onCancelEdition={this.handleOnCancelEdition}
                                                                onProfileChange={this.handleOnProfileChange}
                                                                profileEditionError={this.state.profileEditionError}
                                                                showProfileEditionError={this.state.showProfileEditionError}
                                                                onFailedEditionOK={this.handleOnFailedProfileEditionOK}
                                                                isEdition={this.state.showEditProfile}
                                                                onValidationIncorrect={this.handleOnValidationIncorrect}
                                                                profileEditionInProgress={this.state.profileEditionInProgress}
                                                                clearError={this.clearError}
                                                                isWhiteLabel={this.state.isWhiteLabel}
                                                                onContentChange={this.props.onContentChange}/>; 
        else if(this.state.showAutoSaleQuestionnaire) {
            if (userConnected || this.shouldUseGuestClient()) {
                ordervalidationpanel = (
                    <SaleQuestionnaireFilloutManager 
                        viewProvider={SaleQuestionnaireProvider.default}
                        showInPopup={false}
                        saleQuestionnaires={this.state.saleQuestionnaires}
                        onCancel={this.handleRefreshSaleQuestionnaire}
                        onSave={this.handleRefreshSaleQuestionnaire}
                        onContentChange={this.raiseContentChanged} />
                );
            }
        }
        else
            ordervalidationpanel = (
                <div>
                    <div className="page-header">
                        <h3>{tr("ordervalidation.title")}</h3>
                    </div>

                    {errorOnAction}

                    {cartContentSection}

                    {productSuggestions}

                    {optionsSection}

                    <WholeCartDeliverySelector cartItems={this.state.orderValidation.Cart.Items} mailDeliveryMessage={this.state.mailDeliveryMessage} cartLoaded={cartLoaded} forceDeliveryMethod={this.handleForceDeliveryMethod} />

                    {accountSection}

                    <div id="shippingaddressmodal" ref={this.shippingAddressContainerRef} />
                    <div id="shippingaddresserrormodal" ref={this.shippingAddressErrorContainerRef} />
                    {displayShippingAddressPanel}

                    {autoQuestionnairePanel}                            
                    
                    {policiesSection} 

                    {mailingListsSection}

                    {paymentPanel}

                    {this.state.createHidden3DSIFrame &&
                        <iframe 
                            ref={"threeDSHiddenIframeRef"}
                            id="hidden_payment3dshidden_iframe" 
                            name="hidden_payment3dshidden_iframe" 
                            style={{ 
                                display: "none",
                                width: "600px", // This size is for debugging purposes only. When you want to show the frame.
                                height: "300px",
                            }}>
                        </iframe>
                    }

                    <div className="footer-spacing"></div>
                </div>);

        return(
             <SiteCustomizationContext.Provider value={this.siteSettingsContext}>
                <div className={cIf(this.props.integ, "container-fluid")}>
                    {ordervalidationpanel}
                </div>
            </SiteCustomizationContext.Provider>
        );
        
    }
});




export const Policies = createClass({
    displayName: "Policies",

    propTypes: {
        eventIds: PropTypes.array,
        integ: PropTypes.string,
        onCheckedChange: PropTypes.func,
        initPoliciesRequest: PropTypes.func,
        raiseContentChanged: PropTypes.func
    },

    getInitialState() {
        return { policiesToShow:[] };
    },

    componentDidMount() {
        console.log("Mounting Polices");
        this.loadPolicies();

        if(this.props.raiseContentChanged != null) this.props.raiseContentChanged();
    },

    componentDidUpdate() {
        if(this.props.raiseContentChanged != null) this.props.raiseContentChanged();
    },

    componentWillUnmount() {
        if (this.policiesReq != null) this.policiesReq.abort();
    },

    loadPolicies(){
        //For Now only optionsInfo
        if (this.props.integ != null)
        {
            this.setState({processing:true});
            let policiesReq = this.itemRequest = tsRest.post("integration/" + this.props.integ +  "/policies", { eventIds: this.props.eventIds, lang: tsapp.twoLetterLang });
            policiesReq
                .finally(function(){this.setState({processing:false});}.bind(this))
                .then(function (data) {
                    this.setState({policiesToShow:data});
                    this.props.initPoliciesRequest(data);
                }.bind(this));
        }
    },

    render() {

        let disclaimersSection = null;
        let policiesSection = null;

        if(this.state.policiesToShow.length > 0) {

            const policiesByType = _.groupBy(this.state.policiesToShow, (policy) => {
                if(policy.type == PolicyType.DISCLAIMER || policy.type == null)
                    return "Disclaimers";
                else if(policy.type == PolicyType.POLICY)
                    return "Policies";
                else
                    return "nothing";
            });

            const disclaimersCtl = _.map(policiesByType.Disclaimers, (policy) =>
                <PolicyInfo key={policy.id} policy={policy} onCheckedChange={this.props.onCheckedChange} raiseContentChanged={this.props.raiseContentChanged}/>
            );

            const policiesCtl = _.map(policiesByType.Policies, (policy) =>
                <PolicyInfo key={policy.id} policy={policy} onCheckedChange={this.props.onCheckedChange} raiseContentChanged={this.props.raiseContentChanged}/>
            );

            disclaimersSection = (disclaimersCtl.length > 0) ? (
                <div>
                    <h4>{trN("Décharge de responsabilité", "Décharges de responsabilité", { n: policiesByType.Disclaimers.length })}</h4>
                    {disclaimersCtl}
                </div>
            ) : null;

            policiesSection = (policiesCtl.length > 0) ? (
                <div>
                    <h4>{trN("Politique d'achat", "Politiques d'achat", { n: policiesByType.Policies.length })}</h4>
                    {policiesCtl}
                </div>
            ) : null;
        }
        return <div>
                {disclaimersSection}
                {policiesSection}
        </div>;
    }
});

export const PolicyInfo = createClass({
    displayName: "PolicyInfo",

    propTypes: {
        policy: PropTypes.object.isRequired,
        onCheckedChange: PropTypes.func,
        raiseContentChanged: PropTypes.func
    },

    componentDidMount() {
        if(this.props.raiseContentChanged != null) this.props.raiseContentChanged();
    },

    componentDidUpdate() {
        if(this.props.raiseContentChanged != null) this.props.raiseContentChanged();
    },

    handleOnChange: function(id, checked) {

        this.props.onCheckedChange(id, checked);
    },

    handleUrlOnClick(e, url) {
        e.stopPropagation();
        e.preventDefault();

        window.open(url,'_blank');
    },

    render() {
        const urlHasSomething = (this.props.policy.url != null && this.props.policy.url != "");
        const htmlHasSomething = (this.props.policy.body != null && this.props.policy.body != "");
        let checkboxText = null;
        let urlLink = null;
        let htmlCtl = null;

        if((this.props.policy.type == PolicyType.DISCLAIMER || this.props.policy.type == null) && htmlHasSomething)
            checkboxText = tr("J'ai lu et accepte la décharge");
        else if(this.props.policy.type == PolicyType.DISCLAIMER && urlHasSomething) {
            checkboxText = tr("J'ai lu et accepte la");
            urlLink = <a href="#" onClick={function(e) { this.handleUrlOnClick(e, this.props.policy.url); }.bind(this)}>{tr("décharge")}</a>;
        }
        else if(this.props.policy.type == PolicyType.POLICY && urlHasSomething) {
            checkboxText = tr("J'ai lu et accepte les");
            urlLink = <a href="#" onClick={function(e) { this.handleUrlOnClick(e, this.props.policy.url); }.bind(this)}>{tr("politiques d'achats")}</a>;
        }
        else if(this.props.policy.type == PolicyType.POLICY && htmlHasSomething)
            checkboxText = tr("J'ai lu et accepte les politiques d'achats");

        if(htmlHasSomething)
            htmlCtl = <div dangerouslySetInnerHTML={{__html: this.props.policy.body}} style={{maxHeight:"300px", overflowY: "scroll" }}></div>;
        // else
        // on pourra éventuellement supporter le markdown


        const title = (this.props.policy.title != null && this.props.policy.title != "") ?
            <h4>
                <i className="fa fa-file-text"></i>&nbsp;
                <a href="#">{this.props.policy.title}</a>
            </h4>
            : null;

        return (<div key={this.props.policy.id} className="well">
                {title}
                {htmlCtl}
                <div className="checkbox">
                    <strong>
                        <label>
                            <input type="checkbox" onChange={function(e) { this.handleOnChange(this.props.policy.id, e.target.checked); }.bind(this)}></input> {checkboxText} {urlLink}
                        </label>
                    </strong>
                </div>
        </div>);
    }
});

export const UserAddressInfo = createClass({
    displayName: "UserAddressInfo",

    propTypes: {
        hasMailDeliveries: PropTypes.bool,
        orderValidation: PropTypes.object,
        onUpdateSelectedShippingAddress: PropTypes.func,
        selectedShippingAddressID: PropTypes.string,
        allShippingAddresses: PropTypes.array,
        onShowShippingAddressPanel: PropTypes.func,
        onEditProfile: PropTypes.func
    },

    handleOnUpdateSelectedShippingAddress(shippingAddressID){
        this.props.onUpdateSelectedShippingAddress(shippingAddressID);
    },

    handleOnShowShippingAddressPanel(){
        this.props.onShowShippingAddressPanel();
    },

    handleEditProfile(){
        this.props.onEditProfile();
    },

    displayShippingAddresses(){

        let shippingAddresses = null,
            shippingAddressesCtls = null,
            selectedShippingAddress = null,
            shippingAddressDesc = "",
            chosenAddressInfo = null;

        shippingAddresses = _.concat([ { ID : EMPTY_UUID, Description: tr("ordervalidation.profileaddress") }],
                                        this.props.allShippingAddresses);

        shippingAddressesCtls = shippingAddresses.map(function(shippingAddress){
            return (
                <li key={shippingAddress.ID}>
                    <a href="#" onClick={function(e) { e.stopPropagation(); e.preventDefault(); this.handleOnUpdateSelectedShippingAddress(shippingAddress.ID); }.bind(this)}>{shippingAddress.Description}</a>
                </li>
            );}.bind(this));

        selectedShippingAddress = _.head(shippingAddresses.filter((s) => s.ID === this.props.selectedShippingAddressID));

        if (selectedShippingAddress != null)
        {
            shippingAddressDesc = selectedShippingAddress.Description;
            chosenAddressInfo = <address>
                    {this.props.orderValidation.BillingAddress.Description}<br/>
                    {this.props.orderValidation.BillingAddress.Address1}<br/>
                    {this.props.orderValidation.BillingAddress.Address2}<br/>
                    {this.props.orderValidation.BillingAddress.City}<br/>
                    {this.props.orderValidation.BillingAddress.Province + ", " + this.props.orderValidation.BillingAddress.Country}<br/>
                    {this.props.orderValidation.BillingAddress.PostalCode}<br/>
            </address>;
        }

        if (selectedShippingAddress != null && selectedShippingAddress.ID != EMPTY_UUID)
            chosenAddressInfo = <address>
                {selectedShippingAddress.Name}<br/>
                {selectedShippingAddress.Address1}<br/>
                {selectedShippingAddress.Address2}<br/>
                {selectedShippingAddress.City}<br/>
                {selectedShippingAddress.Province + ", " + selectedShippingAddress.Country}<br/>
                {selectedShippingAddress.PostalCode}<br/>
            </address>;

            return (<div className="col-md-6">
                <h4>{tr("ordervalidation.shippingaddress")}</h4>
                <div className="well">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="btn-toolbar">
                                <button className="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" id="shippingAddress" aria-haspopup="true" aria-expanded="true">
                                    {shippingAddressDesc}&nbsp;
                                    <span className="caret"></span>
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="deliveryDropdown">
                                    {shippingAddressesCtls}
                                </ul>
                                <button className="btn btn-default icon-btn" type="button" onClick={this.handleOnShowShippingAddressPanel}>
                                    <span className="glyphicon glyphicon-pencil"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row"><div className="col-md-12">{chosenAddressInfo}</div></div>
                </div>
            </div>);
    },

    render(){

        let shippingAddresses = "";

        if (this.props.hasMailDeliveries)
            shippingAddresses = this.displayShippingAddresses();

        return(
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <h4>{tr("ordervalidation.yourinfo")}</h4>
                        <form className="well">
                            <div className="row">
                                <div className="col-md-12">
                                    <button className="btn btn-default" type="button" onClick={this.handleEditProfile}>
                                        <span className="glyphicon glyphicon-pencil"></span> {tr("ordervalidation.editprofile")}
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <address>
                                        {this.props.orderValidation.BillingAddress.Description}<br/>
                                        {this.props.orderValidation.BillingAddress.Address1}<br/>
                                        {this.props.orderValidation.BillingAddress.Address2}<br/>
                                        {this.props.orderValidation.BillingAddress.City}<br/>
                                        {this.props.orderValidation.BillingAddress.Province + ", " + this.props.orderValidation.BillingAddress.Country}<br/>
                                        {this.props.orderValidation.BillingAddress.PostalCode}<br/>
                                    </address>
                                </div>
                            </div>
                        </form>
                    </div>
                    {shippingAddresses}
                </div>
            </div>
        );
    }
});
